import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { Bin } from 'chezy-inventory-backend/bin/database/types/Bin'
import { useEffect, useState } from 'react'

import { BinWithChildren, mkBinHeirarchy } from '../../utils/createBinTree'

import { BinOutline } from './binOutline'

const SelectDestinationForm = (props: {
  isOpen: boolean
  binList: Bin[]
  onDismiss: () => void
  onSave: (selectedId: string | undefined) => void
}) => {
  const [tree, setTree] = useState<BinWithChildren[]>([])

  useEffect(() => {
    setTree(mkBinHeirarchy(props.binList, undefined))
  }, [props.binList])

  return (
    <Dialog open={props.isOpen} onClose={props.onDismiss} PaperProps={{ style: { minWidth: 500 } }}>
      <DialogTitle>Select a destination</DialogTitle>
      <DialogContent>
        <p
          style={{
            textDecoration: 'underline',
            color: 'blue',
            cursor: 'pointer',
          }}
          onClick={() => props.onSave(undefined)}
        >
          Top Level Tote
        </p>
        <BinOutline bins={tree} onClick={(id) => props.onSave(id)} />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onDismiss} color="error">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export { SelectDestinationForm }
